import { Col, ColType, Crud, CrudApi } from "../../comp/crud";
import { ApiClient } from "../../api/ApiClient";

import { Form, Modal, Typography, Tag, Tabs, TabPane } from "@douyinfe/semi-ui";
import { formatFloat, formatDate } from "../../utils";
import React, { useState, useEffect } from "react";
import LeadReportItem from "./leadReportItem";
import { LeadReportItemProps } from "./leadReportItem";
import {IconUserGroup, IconUser, IconModalStroked} from "@douyinfe/semi-icons";

const apiClient = ApiClient.getDefault();
export default function AssignVisitStat() {
  const [crudApiUser, setCrudApiUser] = useState(
    undefined as undefined | CrudApi
  );
  const [showLeadItemModalUser, setShowLeadItemModalUser] = useState(false);
  const [leadReportItemPropsUser, setLeadReportItemPropsUser] = useState(
    undefined as undefined | LeadReportItemProps
  );
  const username = localStorage.getItem("username");
  const role = localStorage.getItem("role");

  let colsUser: Col[] = [
    {
      name: "姓名",
      width: 180,
      showInFilter: false,
      key: "name",
      type: ColType.STRING,
      render: (value, record, index) => {
        if (record.type == "org") {
          return (
            <Typography.Text strong type="warning">
              {value}
            </Typography.Text>
          );
        } else {
          return <Typography.Text strong>{value}</Typography.Text>;
        }
      },
    },
    {
      name: "城市",
      width: 80,
      key: "city",
      colSort: 2,
      hideInList: false,
      showInFilter: true,
      type: ColType.SELECT,
      getOptions: () => apiClient.getDictAsOpts("city"),
    },

    {
      name: "新客分配数",
      width: 150,
      key: "assignCount",
      type: ColType.NUMBER,
      defaultSortOrder: "descend",
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.realId, "assign", record.type, -1, record.name);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "上门数",
      width: 100,
      key: "visitCount",
      defaultSortOrder: false,
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.realId, "visit", record.type, -1, record.name);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "0星",
      width: 80,
      key: "star0",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.realId, "visit", record.type, 0, record.name);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "1星",
      width: 80,
      key: "star1",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.realId, "visit", record.type, 1, record.name);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "2星",
      width: 80,
      key: "star2",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.realId, "visit", record.type, 2, record.name);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "3星",
      width: 80,
      key: "star3",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.realId, "visit", record.type, 3, record.name);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "4星",
      width: 80,
      key: "star4",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.realId, "visit", record.type, 4, record.name);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },

    {
      name: "5星",
      width: 80,
      key: "star5",
      type: ColType.NUMBER,
      render: (value, record, index) => {
        return (
          <Typography.Text
            link
            onClick={() => {
              openLeadItemModalUser(record.realId, "visit", record.type, 5, record.name);
            }}
          >
            {value}
          </Typography.Text>
        );
      },
    },
    {
      name: "成本",
      width: 80,
      key: "cost",
      type: ColType.NUMBER,
    },
    {
      name: "费用",
      width: 80,
      key: "costAccumulation",
      type: ColType.NUMBER,
    },

    {
      name: "销售",
      key: "saleIds",
      colSort: 3,
      hideInCreate: true,
      showInFilter: true,
      hideInList: true,
      type: ColType.TREE_MUL,
      getOptions: () => {
        if(role == "op_manager" || role == "monitor"){
          return apiClient.getTeamMemberTreeAsOpts("root");
        }else{
          return apiClient.getTeamMemberTreeAsOpts(username);
        }
      }
    },
    {
      name: "日期",
      key: "createdAt",
      hideInList: true,
      showInFilter: true,
      type: ColType.DATE_RANGE,
    },
    {
      name: "团队",
      key: "teamId",
      type: ColType.TREE,
      getOptions: (row) => apiClient.getTeamAsOpts(),
      hideInList: true,
      showInFilter: true,
    },
  ];

  let nowDate = new Date();
  let nowDateStr = formatDate(nowDate);
  const [initFilterValues, setInitFilterValues] = useState({
    createdAt: [nowDate, nowDate],
  });

  const initParams = {
    createdAt: nowDateStr + "," + nowDateStr,
  };

  const openLeadItemModalUser = async (
    id: number,
    dataType: string,
    type: string,
    star: number,
    name: string,
  ) => {
    let queryParams = crudApiUser?.getQueryParams();
    let createdDate;
    if (type == "date") {
      createdDate = name;
    }
    let otherCondition = "";
    if(type=="sum"){
        id = 0;
        otherCondition = "teamUsers"
    }
    console.log(id);
    let p: LeadReportItemProps = {
      reportType: "StatAssignVisit",
      dataType: dataType,
      ...queryParams,
      userId: id,
      createdDate: createdDate,
      star: star,
      otherCondition: otherCondition,
    };
    setLeadReportItemPropsUser(p);
    setShowLeadItemModalUser(true);
  };

  return (
    <>
      <Tabs type="line" style={{ margin: 10 }}>
        <TabPane
          tab={
            <span>
              <IconUser />
              用户维度
            </span>
          }
          itemKey="2"
        >
          <Modal
              icon={<IconModalStroked size={"extra-large"} style={{ color: 'blue' }}/>}
            fullScreen
            title="客户列表"
            visible={showLeadItemModalUser}
            hasCancel={false}
            onCancel={() => setShowLeadItemModalUser(false)}
            okType="tertiary"
            okText="关闭"
            onOk={() => setShowLeadItemModalUser(false)}
              contentStyle={{ overflow: 'auto' }}
              bodyStyle={{
                height: '100%',
                padding: 0,
                overflow: 'hidden' // 父级隐藏滚动条，由内容自己管理
              }}
          >
            <LeadReportItem
              reportType={leadReportItemPropsUser?.reportType}
              dataType={leadReportItemPropsUser?.dataType}
              createdAt={leadReportItemPropsUser?.createdAt}
              teamId={leadReportItemPropsUser?.teamId}
              city={leadReportItemPropsUser?.city}
              star={leadReportItemPropsUser?.star}
              userId={leadReportItemPropsUser?.userId}
              saleIds={leadReportItemPropsUser?.saleIds}
              createdDate={leadReportItemPropsUser?.createdDate}
              otherCondition={leadReportItemPropsUser?.otherCondition}
            ></LeadReportItem>
          </Modal>
          <Crud
            getCrudApi={(crudApi) => {
              setCrudApiUser(crudApi);
            }}
            canExport={true}
            name="成员KPI报表"
            initFilterValues={initFilterValues}
            params={initParams}
            entityKey="statAssignVisit/byUser"
            pageSize={500}
            rowActionWidth={0}
            cols={colsUser}
          />
        </TabPane>
      </Tabs>
    </>
  );
}
